const store = {
    namespaced: true,
    state: {
        flashes: []
    },
    getters: {
        getCurrentStateFlashes: function(state) {
            return state.flashes.filter(function(flash) {
                return flash.onlyNextRoute === false;
            });
        }
    },
    mutations: {
        /**
         * Add info into flash list.
         *
         * @param {Object} state The store's state.
         * @param {Object} flash An object representing a flash message, following parameters are allowed:
         *   - message: The flash message
         *   - onlyCurrentRoute: The flash message will be destroyed on any state change (see plugins/router.js file).
         *   - onlyNextRoute: The flash will be created only when the next state load,
         *                    and will be destroyed after this state (see plugins/router.js file). It's like
         *                    onlyCurrentRoute but starting at the next router load.
         *   - timeout: The timeout in MS of the flash message, default will be 5 second.
         */
        addFlash: function(state, flash) {
            const id = Math.random().toString(36).substr(2, 9);
            const nextState = flash.onlyNextRoute || false;
            const timeout = flash.timeout || 5000;
            let timer = undefined;

            if (nextState === false) {
                timer = setTimeout(function() {
                    // We remove any flash that should be gone
                    let i = state.flashes.length;
                    while(i--) {
                        if (state.flashes[i].id === id) {
                            state.flashes.splice(i, 1);
                        }
                    }
                }, timeout);
            }

            state.flashes.push({
                id: id,
                type: flash.type || "success",
                message: flash.message || undefined,
                onlyCurrentRoute: flash.onlyCurrentRoute || false,
                onlyNextRoute: nextState,
                timeout: timeout,
                timer: timer
            });
        },

        /**
         * Remove a flash message from the flash list, based on it's id.
         *
         * @param {Object} state The store's state.
         * @param {String} id The flash id to remove.
         */
        removeFlash: function(state, id) {
            let i = state.flashes.length;
            while(i--) {
                if (state.flashes[i].id === id) {
                    state.flashes.splice(i, 1);
                }
            }
        },

        /**
         * Remove flash that are scoped to any route.
         *
         * @param {Object} state The store's state.
         */
        removeRouteFlashes: function(state) {
            let i = state.flashes.length;
            let flash;
            const trues = [true, 1, "true", "True", "t"];

            while(i--) {
                flash = state.flashes[i];
                // Deleting error which are bounds into this state
                if (trues.indexOf(flash.onlyCurrentRoute) >= 0) {
                    clearTimeout(flash.timer);
                    state.flashes.splice(i, 1);
                }
            }
        },

        /**
         * When changing route, if we got flash message that are supposed
         * to be seen on "next" route, we activate them.
         *
         * @param {Object} state The store's state.
         */
        showNextRouteFlashes: function(state) {
            let i = state.flashes.length;
            const trues = [true, 1, "true", "True", "t"];

            while(i--) {
                (function(flash) {
                    // Moving "next state" flash into current state
                    if (trues.indexOf(flash.onlyNextRoute) >= 0) {
                        flash.onlyCurrentRoute = true;
                        flash.onlyNextRoute = false;
                        const timer = setTimeout(function() {
                            // We remove any flash that should be gone
                            let i = state.flashes.length;
                            while(i--) {
                                if (state.flashes[i].id === flash.id) {
                                    state.flashes.splice(i, 1);
                                }
                            }
                        }, flash.timeout);
                        flash.timer = timer;
                    }
                })(state.flashes[i]);
            }
        }
    }
};

export default store;